import styled from 'styled-components';
import theme from 'theme/theme';
import media from 'utils/MediaQueries';
import {
	PAGE_MAX,
	PAGE_PAD,
	PAGE_PAD_MOBILE,
} from 'components/Section/styled';

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Intro = styled.div`
	width: 100%;
	max-width: ${PAGE_MAX};
	padding: 0 ${PAGE_PAD};
	margin-top: 170px;
	margin-bottom: 20px;

	${media.tablet`
		margin-top: 110px;
		padding: 0 ${PAGE_PAD_MOBILE};
	`};

	${media.phone`
		margin-top: 90px;
	`};
`;

const IntroEyebrow = styled.span`
	display: block;
	color: ${theme.primary1};
	font-size: 12px;
	font-weight: 700;
	letter-spacing: 2.2px;
	text-transform: uppercase;
	margin-bottom: 18px;
`;

const IntroTitle = styled.h1`
	font-family: ${theme.headerFont};
	color: ${theme.primary1};
	font-size: 44px;
	line-height: 1.18;
	max-width: 720px;
	margin: 0 0 22px 0;

	${media.phone`
		font-size: 30px;
	`};
`;

const IntroLead = styled.p`
	max-width: 620px;
	margin: 0;
	font-size: 18px;
	line-height: 1.65;
	color: ${theme.text1};
	opacity: 0.78;
`;

const Closing = styled.div`
	width: 100%;
	max-width: ${PAGE_MAX};
	padding: 0 ${PAGE_PAD} 104px ${PAGE_PAD};
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	${media.tablet`
		padding: 0 ${PAGE_PAD_MOBILE} 64px ${PAGE_PAD_MOBILE};
	`};
`;

const ClosingTitle = styled.h2`
	font-family: ${theme.headerFont};
	color: ${theme.text1};
	font-size: 30px;
	margin: 0 0 14px 0;

	${media.phone`
		font-size: 24px;
	`};
`;

const ClosingText = styled.p`
	max-width: 560px;
	margin: 0 0 26px 0;
	font-size: 16px;
	line-height: 1.7;
	color: ${theme.text1};
	opacity: 0.72;
`;

export {
	Wrapper,
	Intro,
	IntroEyebrow,
	IntroTitle,
	IntroLead,
	Closing,
	ClosingTitle,
	ClosingText,
};
